"use client";

import { MessageCircle, Heart, Share2 } from "lucide-react";
import { Button } from "../ui/Button";

interface ProductCTAProps {
  isLiked: boolean;
  isDisabled?: boolean;
  isOwner?: boolean;
  onChat: () => void;
  onLike: () => void;
  onShare?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

export function ProductCTA({
  isLiked,
  isDisabled = false,
  isOwner = false,
  onChat,
  onLike,
  onShare,
  onEdit,
  onDelete,
}: ProductCTAProps) {
  if (isOwner) {
    return (
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-50 shadow-lg safe-area-inset-bottom">
        <div className="max-w-screen-sm mx-auto flex gap-3">
          <Button
            onClick={onEdit}
            variant="outline"
            className="flex-1"
          >
            수정하기
          </Button>
          <Button
            onClick={onDelete}
            variant="danger"
            className="flex-1"
          >
            삭제하기
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-50 shadow-lg safe-area-inset-bottom">
      <div className="max-w-screen-sm mx-auto flex gap-3">
        <button
          onClick={onLike}
          className={`p-4 rounded-2xl border-2 transition-all flex-shrink-0 ${
            isLiked
              ? "bg-red-50 border-red-200 text-red-500"
              : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50"
          }`}
          aria-label={isLiked ? "찜하기 해제" : "찜하기"}
        >
          <Heart
            className={`w-6 h-6 ${isLiked ? "fill-current" : ""}`}
          />
        </button>
        {onShare && (
          <button
            onClick={onShare}
            className="p-4 rounded-2xl border-2 border-gray-200 text-gray-600 hover:bg-gray-50 transition-all flex-shrink-0"
            aria-label="공유하기"
          >
            <Share2 className="w-6 h-6" />
          </button>
        )}
        <Button
          onClick={onChat}
          disabled={isDisabled}
          className={`flex-1 font-semibold py-4 text-base rounded-2xl ${
            isDisabled
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-gradient-to-r from-[#6C4DE6] to-[#8160F0] hover:from-[#5A3FE8] hover:to-[#9575FF] text-white"
          }`}
        >
          <MessageCircle className="w-5 h-5 mr-2" />
          채팅하기
        </Button>
      </div>
    </div>
  );
}

